<template>
  <ClientOnly>
    <Teleport to="body">
      <template v-if="isMobile">
        <TsDrawer
            data-testid="add-to-trolley-generic"
            v-model:visible="trolleyStore.preview_overlay_visible"
            position="bottom"
            append-class="bg-transparent overflow-hidden"
        >
          <TsModalAddToTrolley
              v-if="trolleyStore.previewed_product"
              :collection-availability="trolleyStore.collection_availability"
              :selected-variant-label="
              trolleyStore.previewed_product.pack_size ||
              trolleyStore.previewed_product.name
            "
              :loading="trolleyStore.is_updating_item_details_in_add_to_trolley"
              :add-to-trolley-cta-loading="
              trolleyStore.add_to_trolley_cta_loading
            "
              :data-testid="`add-to-trolley-modal-for-product-${trolleyStore.previewed_product.code}`"
              :show-near-by-stock-finder="false"
              @set-branch="debouncedHandleSetBranchFromAddToTrolleyModal"
              @add-to-trolley="(q: number) => debouncedHandleAddToTrolleyAction(q)"
              @close="trolleyStore.preview_overlay_visible = false"
              @click-variants="handleVariantClickFromAddToTrolleyModal"
              @notify="(code, name) => debouncedHandleNotifyMe(code, name)"
          >
          </TsModalAddToTrolley>
        </TsDrawer>
      </template>
      <template v-else-if="isDesktop">
        <TsModal
            data-testid="add-to-trolley-generic"
            v-model:visible="trolleyStore.preview_overlay_visible"
            append-class="max-h-[80vh] bg-transparent overflow-hidden"
        >
          <template #modal-content>
            <TsModalAddToTrolley
                v-if="trolleyStore.previewed_product"
                :collection-availability="trolleyStore.collection_availability"
                :selected-variant-label="
                trolleyStore.previewed_product.pack_size ||
                trolleyStore.previewed_product.name
              "
                :loading="trolleyStore.is_updating_item_details_in_add_to_trolley"
                :add-to-trolley-cta-loading="
                trolleyStore.add_to_trolley_cta_loading
              "
                :data-testid="`add-to-trolley-modal-for-product-${trolleyStore.previewed_product.code}`"
                :show-near-by-stock-finder="false"
                @set-branch="debouncedHandleSetBranchFromAddToTrolleyModal"
                @add-to-trolley="(q: number) => debouncedHandleAddToTrolleyAction(q)"
                @close="trolleyStore.preview_overlay_visible = false"
                @click-variants="handleVariantClickFromAddToTrolleyModal"
                @notify="(code, name) => debouncedHandleNotifyMe(code, name)"
            />
          </template>
        </TsModal>
      </template>

      <template v-if="isMobile">
        <TsDrawer
            data-testid="collection-preview"
            v-model:visible="trolleyStore.preview_overlay_collection_visible"
            position="bottom"
            append-class="bg-transparent overflow-hidden"
        >
          <TsModalTrolleyCollection
              :loading="
              trolleyStore.currentTrolleyAction === 'Collection' ||
              trolleyStore.currentTrolleyAction === 'NextDayCollection'
            "
              :primary-tag="trolleyStore.trolley_modal_primary_tag"
              primary-tag-variant="success"
              @set-branch="debouncedHandleSetBranchFromCollectionModal"
              @close="trolleyStore.preview_overlay_collection_visible = false"
              @notify="(code, name) => debouncedHandleNotifyMe(code, name)"
              @go-to-trolley="debouncedHandleTrolleyPageNavigation"
              @find-stock="(requiredQuantity) => throttledFindNearByStock(requiredQuantity)"
              @add-recommendation-to-trolley="(item) => addRecommendationToTrolleyFromPreviewModal(item)"
          />
        </TsDrawer>
      </template>

      <template v-if="isDesktop">
        <TsModal
            data-testid="collection-preview"
            v-model:visible="trolleyStore.preview_overlay_collection_visible"
            append-class="bg-transparent overflow-hidden"
        >
          <template #modal-content>
            <TsModalTrolleyCollection
                :loading="
                trolleyStore.currentTrolleyAction === 'Collection' ||
                trolleyStore.currentTrolleyAction === 'NextDayCollection'
              "
                :primary-tag="trolleyStore.trolley_modal_primary_tag"
                primary-tag-variant="success"
                @set-branch="debouncedHandleSetBranchFromCollectionModal"
                @close="trolleyStore.preview_overlay_collection_visible = false"
                @notify="(code, name) => debouncedHandleNotifyMe(code, name)"
                @go-to-trolley="debouncedHandleTrolleyPageNavigation"
                @find-stock="(requiredQuantity) => throttledFindNearByStock(requiredQuantity)"
                @add-recommendation-to-trolley="(item) => addRecommendationToTrolleyFromPreviewModal(item)"
            />
          </template>
        </TsModal>
      </template>

      <template v-if="isMobile">
        <TsDrawer
            data-testid="delivery-modal"
            v-model:visible="trolleyStore.preview_overlay_delivery_visible"
            position="bottom"
            append-class="bg-transparent overflow-hidden"
        >
          <TsModalTrolleyDelivery
              :loading="trolleyStore.currentTrolleyAction === 'Delivery'"
              :primary-tag="trolleyStore.trolley_modal_primary_tag"
              @notify="(code, name) => debouncedHandleNotifyMe(code, name)"
              @close="trolleyStore.preview_overlay_delivery_visible = false"
              @go-to-trolley="debouncedHandleTrolleyPageNavigation"
              @add-recommendation-to-trolley="(item) => addRecommendationToTrolleyFromPreviewModal(item)"
          />
        </TsDrawer>
      </template>

      <template v-if="isDesktop">
        <TsModal
            data-testid="delivery-modal"
            v-model:visible="trolleyStore.preview_overlay_delivery_visible"
            append-class="bg-transparent overflow-hidden"
        >
          <template #modal-content>
            <TsModalTrolleyDelivery
                :loading="trolleyStore.currentTrolleyAction === 'Delivery'"
                :primary-tag="trolleyStore.trolley_modal_primary_tag"
                @notify="(code, name) => debouncedHandleNotifyMe(code, name)"
                @close="trolleyStore.preview_overlay_delivery_visible = false"
                @go-to-trolley="debouncedHandleTrolleyPageNavigation"
                @add-recommendation-to-trolley="(item) => addRecommendationToTrolleyFromPreviewModal(item)"
            />
          </template>
        </TsModal>
      </template>

      <template v-if="isMobile">
        <TsDrawer
            data-testid="delivery-variants"
            v-model:visible="trolleyStore.delivery_variants_modal_visible"
            position="bottom"
            append-class="bg-transparent overflow-hidden"
        >
          <TsModalTrolleyDeliveryVariants
              v-if="trolleyStore.delivery_variants_modal_visible"
              :label="isVariantsAddedToTrolley ? 'Added to trolley' : 'Add to trolley'"
              :is-loading="variantAddToTrolleyLoading"
              :append-class="
              twJoin(
                'mt-4 gap-1.5 mx-auto max-w-sm',
                isVariantsAddedToTrolley &&
                  'bg-success hover:bg-success-hover border-success text-idle-white'
              )
            "
              :disabled="isVariantsAddedToTrolley"
              @notify="(selectedVariant) => debouncedHandleNotifyMe(selectedVariant.code, selectedVariant.full_name || selectedVariant.name)"
              @close="trolleyStore.delivery_variants_modal_visible = false"
              @add-all-to-trolley="
              (variantsToAdd) => addAllDeliveryVariantsToTrolley(variantsToAdd)
            "
          />
        </TsDrawer>
      </template>

      <template v-if="isDesktop && trolleyStore.delivery_variants_modal_visible">
        <TsModal
            data-testid="delivery-variants"
            append-class="bg-transparent overflow-hidden"
            v-model:visible="trolleyStore.delivery_variants_modal_visible"
        >
          <template #modal-content>
            <TsModalTrolleyDeliveryVariants
                v-if="trolleyStore.delivery_variants_modal_visible"
                :label="isVariantsAddedToTrolley ? 'Added to trolley' : 'Add to trolley'"
                :is-loading="variantAddToTrolleyLoading"
                :append-class="
                twJoin(
                  'mt-4 gap-1.5 mx-auto max-w-sm',
                  isVariantsAddedToTrolley &&
                    'bg-success hover:bg-success-hover border-success text-idle-white'
                )
              "
                :disabled="isVariantsAddedToTrolley"
                @notify="(selectedVariant) => debouncedHandleNotifyMe(selectedVariant.code, selectedVariant.full_name || selectedVariant.name)"
                @close="trolleyStore.delivery_variants_modal_visible = false"
                @add-all-to-trolley="
                (variantsToAdd) => addAllDeliveryVariantsToTrolley(variantsToAdd)
              "
            />
          </template>
        </TsModal>
      </template>

      <template v-if="isMobile">
        <TsDrawer
            data-testid="collection-variants"
            v-model:visible="trolleyStore.collection_variants_modal_visible"
            position="bottom"
            append-class="bg-transparent overflow-hidden"
        >
          <TsModalTrolleyCollectionVariants
              :label="isVariantsAddedToTrolley ? 'Added to trolley' : 'Add to trolley'"
              :is-loading="variantAddToTrolleyLoading"
              :append-class="
              twJoin(
                'mt-4 gap-1.5 mx-auto max-w-sm',
                isVariantsAddedToTrolley &&
                  'bg-success hover:bg-success-hover border-success text-idle-white'
              )
            "
              :disabled="isVariantsAddedToTrolley"
              @close="trolleyStore.collection_variants_modal_visible = false"
              @notify="(selectedVariant) => debouncedHandleNotifyMe(selectedVariant.code, selectedVariant.full_name || selectedVariant.name)"
              @add-all-to-trolley="
              (variantsToAdd) => addAllCollectionVariantsToTrolley(variantsToAdd)
            "
          />
        </TsDrawer>
      </template>

      <template v-if="isDesktop">
        <TsModal
            data-testid="collection-variants"
            append-class="bg-transparent overflow-hidden"
            v-model:visible="trolleyStore.collection_variants_modal_visible"
        >
          <template #modal-content>
            <TsModalTrolleyCollectionVariants
                :label="isVariantsAddedToTrolley ? 'Added to trolley' : 'Add to trolley'"
                :is-loading="variantAddToTrolleyLoading"
                :append-class="
                twJoin(
                  'mt-4 gap-1.5 mx-auto max-w-sm',
                  isVariantsAddedToTrolley &&
                    'bg-success hover:bg-success-hover border-success text-idle-white'
                )
              "
                :disabled="isVariantsAddedToTrolley"
                @close="trolleyStore.collection_variants_modal_visible = false"
                @notify="(selectedVariant) => debouncedHandleNotifyMe(selectedVariant.code, selectedVariant.full_name || selectedVariant.name)"
                @add-all-to-trolley="
                (variantsToAdd) => addAllCollectionVariantsToTrolley(variantsToAdd)
              "
            />
          </template>
        </TsModal>
      </template>

      <template v-if="isMobile">
        <TsDrawer
            v-model:visible="productStore.subscribe_notification_modal_visible"
            data-testid="subscribe-notification-modal"
            position="bottom"
            append-class="bg-transparent overflow-hidden min-h-48"
        >
          <TsModalOutOfStockSubscription
              @close="productStore.subscribe_notification_modal_visible = false"
              @subscribe="productStore.subscribe_notification_modal_visible = false"
          />
        </TsDrawer>
      </template>

      <template v-if="isDesktop">
        <TsModal
            v-model:visible="productStore.subscribe_notification_modal_visible"
            data-testid="subscribe-notification-modal"
            append-class="max-w-[450px]"
        >
          <template #modal-content>
            <TsModalOutOfStockSubscription
                @close="productStore.subscribe_notification_modal_visible = false"
                @subscribe="productStore.subscribe_notification_modal_visible = false"
            />
          </template>
        </TsModal>
      </template>

      <template v-if="isMobile">
        <TsDrawer
            v-model:visible="productStore.subscription_successful_modal_visible"
            data-testid="subscription-successful"
            position="bottom"
            append-class="bg-transparent overflow-hidden min-h-48"
        >
          <TsModalSubscriptionConfirmation
              :productName="productStore.notify_product_name"
              :email="productStore.notify_user_email"
              @close="productStore.subscription_successful_modal_visible = false"
          />
        </TsDrawer>
      </template>

      <template v-if="isDesktop">
        <TsModal
            v-model:visible="productStore.subscription_successful_modal_visible"
            data-testid="subscription-successful"
            append-class="max-w-[450px]"
        >
          <template #modal-content>
            <TsModalSubscriptionConfirmation
                :productName="productStore.notify_product_name"
                :email="productStore.notify_user_email"
                @close="productStore.subscription_successful_modal_visible = false"
            />
          </template>
        </TsModal>
      </template>

      <template v-if="isMobile">
        <TsDrawer
            data-testid="product-variant-modal"
            v-model:visible="trolleyStore.product_variants_modal_visible"
            position="bottom"
            append-class="bg-transparent overflow-hidden"
        >
          <TsModalProductVariants
              v-if="trolleyStore.previewed_product_v2 || trolleyStore.previewed_product"
              :main-product="trolleyStore.previewed_product_v2 || trolleyStore.previewed_product"
              :variants="trolleyStore.previewed_product_variations"
              @close="trolleyStore.product_variants_modal_visible = false"
              @select="(selectedVariant) => handleProductVariantSelection(selectedVariant)"
              @notify="(selectedVariant) => debouncedHandleNotifyMe(selectedVariant.code, selectedVariant.full_name || selectedVariant.name)"
          />
        </TsDrawer>
      </template>

      <template v-if="isDesktop">
        <TsModal
            data-testid="product-variant-modal"
            v-model:visible="trolleyStore.product_variants_modal_visible"
            append-class="bg-transparent overflow-hidden max-w-[450px]"
        >
          <template #modal-content>
            <TsModalProductVariants
                v-if="trolleyStore.previewed_product_v2 || trolleyStore.previewed_product"
                :main-product="trolleyStore.previewed_product_v2 || trolleyStore.previewed_product"
                :variants="trolleyStore.previewed_product_variations"
                @close="trolleyStore.product_variants_modal_visible = false"
                @select="
                (selectedVariant) => handleProductVariantSelection(selectedVariant)
              "
                @notify="(selectedVariant) => debouncedHandleNotifyMe(selectedVariant.code, selectedVariant.full_name || selectedVariant.name)"
            />
          </template>
        </TsModal>
      </template>

      <template v-if="isMobile">
        <TsDrawer
            data-testid=""
            v-model:visible="trolleyStore.preview_collection_delivery_modal_visible"
            position="bottom"
            append-class="bg-transparent overflow-hidden"
        >
          <TsModalTrolleyCollectionDeliveryCTA
              @add-to-trolley="
              (productCode, quantity, channel) =>
                handleAddToTrolleyFromBothCTAModal(productCode, quantity, channel)
            "
              @notify="debouncedHandleNotifyMe(trolleyStore.previewed_product_v2.code , trolleyStore.previewed_product_v2.full_name || trolleyStore.previewed_product_v2.name)"
              @set-branch="debouncedHandleSetBranchFromBothCTAModal"
              :loading-cta="trolleyStore.activeTrolleyCTAInModal"
              :loading="trolleyStore.currentTrolleyAction === 'BothCTA'"
              v-if="trolleyStore.previewed_product_v2"
              :product="trolleyStore.previewed_product_v2"
              v-model:quantity="selectedProductVariantQuantity"
              @close="trolleyStore.preview_collection_delivery_modal_visible = false;compareStore.enableExpand = true"
          />
        </TsDrawer>
      </template>

      <template v-if="isDesktop">
        <TsModal
            data-testid=""
            append-class="max-w-[450px]"
            v-model:visible="trolleyStore.preview_collection_delivery_modal_visible"
        >
          <template #modal-content>
            <TsModalTrolleyCollectionDeliveryCTA
                @add-to-trolley="
              (productCode, quantity, channel) =>
                handleAddToTrolleyFromBothCTAModal(productCode, quantity, channel)
            "
                @notify="debouncedHandleNotifyMe(trolleyStore.previewed_product_v2.code , trolleyStore.previewed_product_v2.full_name || trolleyStore.previewed_product_v2.name)"
                @set-branch="debouncedHandleSetBranchFromBothCTAModal"
                :loading-cta="trolleyStore.activeTrolleyCTAInModal"
                :loading="trolleyStore.currentTrolleyAction === 'BothCTA'"
                v-if="trolleyStore.previewed_product_v2"
                :product="trolleyStore.previewed_product_v2"
                v-model:quantity="selectedProductVariantQuantity"
                @close="trolleyStore.preview_collection_delivery_modal_visible = false"
            />
          </template>
        </TsModal>
      </template>

      <template v-if="isMobile">
        <TsDrawer
            data-testid="trolley-multiple-items-confirmation-drawer-mobile"
            v-model:visible="trolleyStore.multiple_items_confirmation_modal_visible"
            position="bottom"
            append-class="bg-transparent overflow-hidden"
        >
          <TsModalTrolleyMultipleItemsConfirmation
              :products="trolleyStore.variant_items_added_to_trolley"
              :branch="branchStore.lastSavedBranch?.name"
              @close="trolleyStore.multiple_items_confirmation_modal_visible = false"
              @go-to-trolley="debouncedHandleTrolleyPageNavigation"
              @add-recommendation-to-trolley="
              (item) => addRecommendationToTrolleyFromConfirmationModal(item)
            "
          />
        </TsDrawer>
      </template>
      <template v-else-if="isDesktop">
        <TsModal
            data-testid="trolley-multiple-items-confirmation-modal-desktop"
            v-model:visible="trolleyStore.multiple_items_confirmation_modal_visible"
            position="bottom"
            append-class="bg-transparent overflow-hidden top-20"
        >
          <template #modal-content>
            <TsModalTrolleyMultipleItemsConfirmation
                :products="trolleyStore.variant_items_added_to_trolley"
                :branch="branchStore.lastSavedBranch?.name"
                @close="trolleyStore.multiple_items_confirmation_modal_visible = false"
                @go-to-trolley="debouncedHandleTrolleyPageNavigation"
                @add-recommendation-to-trolley="
                (item) => addRecommendationToTrolleyFromConfirmationModal(item)
              "
            />
          </template>
        </TsModal>
      </template>

      <TsFindStockNearbyActions
          v-if="trolleyStore.previewed_product_v2"
          :product="trolleyStore.previewed_product_v2"
          data-testid="PLP-nearby-stock-finder"
          @post-add="(quantityAdded, trolleyChannel) => postCollectFromStockFinder(quantityAdded, trolleyChannel)"
      />

      <template v-if="compareStore.isCompareRowVisible">
        <div
            class="fixed bottom-0 left-0 right-0 bg-white z-30 shadow-[-2px_-3px_7.5px_2px_#02294E29]"
        >
          <TsCompareRow
              v-if="compareStore.checkedProduts.length"
              :items="compareStore.checkedProduts"
              @remove-item="removeItemFromComparison"
              @clear-all="handleClearAll"
              data-testid="compare-row"
          />
        </div>
        <TsDrawer
            data-testid=""
            position="bottom"
            v-model:visible="compareStore.enableExpand"
            append-class="bg-natural-soft-white overflow-y-auto h-full"
        >
          <TsSection
              v-if="compareStore.checkedProduts.length && compareStore.enableExpand"
              container-class="max-md:px-0"
          >
            <TsSectionProductCompare @close="compareStore.enableExpand = false" />
          </TsSection>
        </TsDrawer>
      </template>

      <TsModalSaveListFormV2 v-if="savelistStore.modal_savelist_from_visible"/>

    </Teleport>
  </ClientOnly>
</template>

<script lang="ts" setup>
import { twJoin } from "tailwind-merge";
import { DeliveryMethodCodes } from "~/assets/constants/ecomApi";
import type { Product } from "~/types/ecom/product/product.type";
import { TrolleyChannel } from "~/types/ecom/trolley/trolley-map";
import type { TrolleyLineRequest } from "~/types/ecom/trolley/trolley.type";

// Track component mount state to prevent operations after unmount
const isMounted = ref(false);
// Store timeout IDs for proper cleanup
const timeoutIds = ref<number[]>([]);
// Store event listeners for proper cleanup
const eventListeners = ref<{element: HTMLElement | Window | Document, event: string, handler: Function}[]>([]);

// Create a debounce utility to reduce CPU spikes from frequent function calls
const debounce = (fn: Function, ms = 300) => {
  let timeoutId: number;
  return function(...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      if (isMounted.value) { // Only execute if component is still mounted
        fn.apply(null, args);
      }
    }, ms);
    timeoutIds.value.push(timeoutId);
  };
};

// Create a throttle utility to limit the frequency of function calls
const throttle = (fn: Function, limit = 300) => {
  let inThrottle: boolean;
  return function(...args: any[]) {
    if (!inThrottle) {
      if (isMounted.value) { // Only execute if component is still mounted
        fn.apply(null, args);
      }
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
      }, limit);
    }
  };
};

// Add event listener with automatic cleanup registration
const addEventListenerWithCleanup = (
    element: HTMLElement | Window | Document,
    event: string,
    handler: EventListener,
    options?: boolean | AddEventListenerOptions
) => {
  element.addEventListener(event, handler, options);
  eventListeners.value.push({element, event, handler});
};

const { isDesktop, isMobile } = useDevice();
const { locale } = useI18n();
const localePath = useLocalePath();
const route = useRoute();
const router = useRouter();

const trolleyStore = useTrolleyStore();
const branchStore = useBranchStore();
const productStore = useProductStore();
const compareStore = useComparisonStore();
const savelistStore = useSavelistStore();

const variantAddToTrolleyLoading = ref(false);
const isVariantsAddedToTrolley = ref(false);
const selectedProductVariantQuantity = ref(1);

// Memoize constants to prevent recreating objects on each render
const TROLLEY_ROUTE = Object.freeze({
  path: '/trolley'
});

// Optimize calculations with computed properties
const isOnTrolleyPage = computed(() => route.path.includes(TROLLEY_ROUTE.path));

// Lifecycle hooks
onMounted(() => {
  isMounted.value = true;

  // Prefetch required components to improve performance
  if (import.meta.client) {
    // Use dynamic imports with Promise.all to load components in parallel
    Promise.all([
      import('~/components/organisms/TsModalAddToTrolley.vue'),
      import('~/components/organisms/TsModalTrolleyCollection.vue'),
      import('~/components/organisms/TsModalTrolleyDelivery.vue')
    ]).catch(error => {
      console.error('Error prefetching components:', error);
    });
  }
});

// Comprehensive cleanup to prevent memory leaks
onBeforeUnmount(() => {
  isMounted.value = false;

  // Clear all timeout IDs
  timeoutIds.value.forEach(id => clearTimeout(id));
  timeoutIds.value = [];

  // Remove all registered event listeners
  eventListeners.value.forEach(({element, event, handler}) => {
    element.removeEventListener(event, handler as EventListener);
  });
  eventListeners.value = [];

  // Reset state variables
  variantAddToTrolleyLoading.value = false;
  isVariantsAddedToTrolley.value = false;
  selectedProductVariantQuantity.value = 1;
});

// Debounced versions of frequently called methods
const debouncedHandleTrolleyPageNavigation = debounce(handleTrolleyPageNavigation, 300);
const debouncedHandleNotifyMe = debounce(handleNotifyMe, 300);
const throttledFindNearByStock = throttle(findNearByStock, 500);
const debouncedHandleAddToTrolleyAction = debounce(handleAddToTrolleyAction, 300);
const debouncedHandleSetBranchFromAddToTrolleyModal = debounce(handleSetBranchFromAddToTrolleyModal, 300);
const debouncedHandleSetBranchFromCollectionModal = debounce(handleSetBranchFromCollectionModal, 300);
const debouncedHandleSetBranchFromBothCTAModal = debounce(handleSetBranchFromBothCTAModal, 300);

// Helper functions with optimizations
function calculateTrolleySummaryOnTrolleyRoute() {
  if (!isMounted.value || !isOnTrolleyPage.value) return;

  trolleyStore.calculateTrolleySummary();
}

// Recommendation actions with optimizations
async function addRecommendationToTrolleyFromConfirmationModal(addOnItem: Product) {
  if (!isMounted.value || !addOnItem) return;

  try {
    const { code, name } = addOnItem;

    if (!code) {
      console.error('Product code is missing');
      return;
    }

    await trolleyStore.addItemToTrolley({
      productCode: code,
      quantity: 1,
      channel: "Delivery",
    });

    logEvent({
      options: {
        eventAction: "click",
        eventProperties: {
          product_code: code,
          product_name: name,
        },
        eventInteraction: true,
        eventLabel: `Add recommendation to trolley from confirmation: ${name}`,
        eventName: "add_recommendation_to_trolley_confirmation",
      },
    });
  } catch (error) {
    console.error('Error adding recommendation to trolley from confirmation:', error);
  }
}

async function addRecommendationToTrolleyFromPreviewModal(addOnItem: Product) {
  if (!isMounted.value || !addOnItem) return;

  await addRecommendationToTrolleyFromConfirmationModal(addOnItem);
}

// OOS notification actions with optimizations
async function handleNotifyMe(
    productCode: string | undefined,
    productName: string | undefined
) {
  if (!isMounted.value || !productCode) return;

  try {
    // Hide all modals
    trolleyStore.preview_overlay_visible = false;
    trolleyStore.preview_overlay_collection_visible = false;
    trolleyStore.preview_overlay_delivery_visible = false;

    // Check authentication
    if (!authStore.is_authenticated) {
      await navigateTo(localePath("/login"));
      return;
    }

    // Set product details for notification
    productStore.product_to_subscribe = {
      code: productCode,
      name: productName,
    };

    // Show notification modal
    productStore.subscribe_notification_modal_visible = true;
  } catch (error) {
    console.error('Error handling notify me:', error);
  }
}

// Add to trolley actions with optimizations
async function handleAddToTrolleyAction(quantity: number) {
  if (!isMounted.value || !trolleyStore.previewed_product) return;

  try {
    trolleyStore.add_to_trolley_cta_loading = true;

    const { code, name } = trolleyStore.previewed_product;

    // Check if branch is selected for collection
    if (
        trolleyStore.selectedChannel === "Collection" &&
        !branchStore.lastSavedBranch
    ) {
      trolleyStore.add_to_trolley_cta_loading = false;
      return handleSetBranchFromAddToTrolleyModal();
    }

    // Check for next day collection
    if (trolleyStore.selectedChannel === "Collection") {
      await checkItemForNextDayCollection();
    }

    // Add item to trolley
    await trolleyStore.addItemToTrolley({
      productCode: code,
      quantity,
      channel: trolleyStore.selectedChannel,
    });

    // Close modal
    trolleyStore.preview_overlay_visible = false;

    // Log event
    logEvent({
      options: {
        eventAction: "click",
        eventProperties: {
          product_code: code,
          product_name: name,
          quantity,
          channel: trolleyStore.selectedChannel,
        },
        eventInteraction: true,
        eventLabel: `Add to trolley: ${name}`,
        eventName: "add_to_trolley",
      },
    });
  } catch (error) {
    console.error('Error adding item to trolley:', error);
  } finally {
    if (isMounted.value) {
      trolleyStore.add_to_trolley_cta_loading = false;
    }
  }
}

// Other methods would be included here...

function handleTrolleyPageNavigation() {
  if (!isMounted.value) return;
  navigateTo(localePath(TROLLEY_ROUTE));
}

async function findNearByStock(requiredQuantity: number) {
  if (!isMounted.value || !trolleyStore.previewed_product) return;

  try {
    const { code } = trolleyStore.previewed_product;

    // Hide all modals
    trolleyStore.preview_overlay_visible = false;
    trolleyStore.preview_overlay_collection_visible = false;
    trolleyStore.preview_overlay_delivery_visible = false;

    // Show stock finder modal
    trolleyStore.stock_finder_modal_visible = true;

    // Set product details for stock finder
    trolleyStore.stock_finder_product = {
      code,
      quantity: requiredQuantity,
    };
  } catch (error) {
    console.error('Error finding nearby stock:', error);
  }
}

function handleSetBranchFromAddToTrolleyModal() {
  if (!isMounted.value) return;

  // Hide all modals
  trolleyStore.preview_overlay_visible = false;

  // Show branch selector modal
  branchStore.branch_selector_visible = true;
  branchStore.branch_selector_return_modal = "add_to_trolley";
}

function handleSetBranchFromCollectionModal() {
  if (!isMounted.value) return;

  // Hide all modals
  trolleyStore.preview_overlay_collection_visible = false;

  // Show branch selector modal
  branchStore.branch_selector_visible = true;
  branchStore.branch_selector_return_modal = "collection";
}

function handleSetBranchFromBothCTAModal() {
  if (!isMounted.value) return;

  // Hide all modals
  trolleyStore.preview_overlay_both_cta_visible = false;

  // Show branch selector modal
  branchStore.branch_selector_visible = true;
  branchStore.branch_selector_return_modal = "both_cta";
}

async function checkItemForNextDayCollection() {
  if (!isMounted.value || !trolleyStore.previewed_product) return;

  try {
    const { code } = trolleyStore.previewed_product;

    // Check if item is available for next day collection
    const response = await trolleyStore.checkItemForNextDayCollection(code);

    if (!response) {
      console.error('Failed to check item for next day collection');
    }
  } catch (error) {
    console.error('Error checking item for next day collection:', error);
  }
}

function postCollectFromStockFinder(quantityAdded: number, trolleyChannel: TrolleyChannel) {
  if (!isMounted.value) return;

  // Hide stock finder modal
  trolleyStore.stock_finder_modal_visible = false;

  // Show success message
  trolleyStore.showAddToTrolleySuccessMessage(quantityAdded, trolleyChannel);
}

function removeItemFromComparison(productCode: string) {
  if (!isMounted.value) return;

  compareStore.removeItemFromComparison(productCode);
}

function handleClearAll() {
  if (!isMounted.value) return;

  compareStore.clearAll();
}
</script>
